import { render, staticRenderFns } from "./ConnoisseurInfo.vue?vue&type=template&id=01ff6c38&scoped=true&"
import script from "./ConnoisseurInfo.vue?vue&type=script&lang=js&"
export * from "./ConnoisseurInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConnoisseurInfo.vue?vue&type=style&index=0&id=01ff6c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ff6c38",
  null
  
)

export default component.exports